import React from 'react'
// libs
import styled from 'styled-components'
// components
import { Chip as ChipOrigin, TableCell as TableCellOrigin } from '@mui/material'
// themes
import { colors } from 'themes/index'
// icons
import CheckedOriginIcon from '@mui/icons-material/Check'
import DotsIconOrigin from '@mui/icons-material/MoreHorizOutlined'
import ReviewIconOrigin from 'src/icons/review-blue.svg'
// utils
import { size } from 'polished'

// constants
export const ICON_STYLE = { color: colors.white }
export const TEXT_STYLE = { color: colors.blue300, fontWeight: 500 }

interface IChipProps {
  chipColor: string
}

interface ITableCellProps {
  size?: number
  withEllipsis?: boolean
}

const CheckedIcon = styled(CheckedOriginIcon)`
  margin-left: 10px;
  ${size('14px')};
`

const Chip = styled(({ chipColor, rounded, ...props }) => <ChipOrigin {...props} />)<IChipProps>`
  && {
    border-radius: ${({ rounded }) => (rounded ? '25px' : '4px')};
    background-color: ${({ chipColor }) => chipColor};
    color: ${colors.white};
    font-weight: 500;
    width: 108px;
  }
`

const DotsIcon = styled(DotsIconOrigin)`
  && {
    cursor: pointer;
    ${size('18px')};
  }
`

const ReviewIcon = styled(ReviewIconOrigin)`
  && {
    ${size('20px')};

    path {
      fill: ${colors.white100};
    }
  }
`

const TableCell = styled(({ size, withEllipsis, ...props }) => <TableCellOrigin {...props} />)<ITableCellProps>`
  && {
    padding: 14px;
    width: ${({ size }) => (size ? `${size}%` : 'unset')};

    ${({ withEllipsis }) => withEllipsis && 'max-width: 200px'};
  }
`

export { CheckedIcon, Chip, DotsIcon, ReviewIcon, TableCell }
